export enum counselorGenieStages {
  preLead = 'Pre Lead',
  postLead = 'Post Lead',
}
